const jsonLdData = `
 {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.wenodo.com/#organization",
      "name": "Wenodo",
      "url": "https://www.wenodo.com",
      "logo": "https://www.wenodo.com/app-logo.2162d1ad.webp",
      "description": "Wenodo provides Hospitality Accounting, Restaurant Payroll, Consulting, Workforce Management Software, and AI Analytics for restaurants in the UK and UAE.",
      "sameAs": [
        "https://www.instagram.com/wenodo_ltd",
        "https://www.linkedin.com/company/wenodo",
        "https://x.com/WenodoLTD",
        "https://www.facebook.com/people/Wenodo/61555965042636"
      ]
    },
 
    {
      "@type": "LocalBusiness",
      "@id": "https://www.wenodo.com/#localbusiness-uk",
      "parentOrganization": { "@id": "https://www.wenodo.com/#organization" },
      "name": "Wenodo Hospitality Accountant",
      "image": "https://www.wenodo.com/app-logo.2162d1ad.webp",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Garden Suite, 96 Brighton Rd",
        "addressLocality": "Brighton",
        "postalCode": "SM7 1BU",
        "addressCountry": "GB"
      },
      "telephone": "+44 20 8037 7768",
      "url": "https://www.wenodo.com"
    },
 
    {
      "@type": "LocalBusiness",
      "@id": "https://www.wenodo.com/#localbusiness-uae",
      "parentOrganization": { "@id": "https://www.wenodo.com/#organization" },
      "name": "Wenodo Hospitality Accountant ",
      "image": "https://www.wenodo.com/app-logo.2162d1ad.webp",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "WARBA CENTER, 2010, Al Muraqqabat",
        "addressLocality": "Dubai",
        "addressCountry": "AE"
      },
      "telephone": "+971 5050 71859",
      "url": "https://www.wenodo.com"
    },
 
    {
      "@type": "Product",
      "@id": "https://www.wenodo.com/trakn/#product",
      "name": "Trakn AI – Restaurant Analytics Software",
      "image": "https://www.wenodo.com/app-logo.2162d1ad.webp",
      "url": "https://www.wenodo.com/trakn",
      "description": "Trakn AI provides restaurant analytics, labour insights, forecasting, and performance dashboards.",
      "brand": { "@id": "https://www.wenodo.com/#organization" },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "37"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://www.wenodo.com/trakn",
        "price": "0",
        "priceCurrency": "GBP",
        "availability": "https://schema.org/InStock"
      }
    },
 
    {
      "@type": "Product",
      "@id": "https://www.wenodo.com/staflexx/#product",
      "name": "Staflexx – Hospitality Workforce Management Software",
      "image": "https://www.wenodo.com/app-logo.2162d1ad.webp",
      "url": "https://www.wenodo.com/staflexx",
      "description": "Staflexx helps restaurants manage staff scheduling, attendance, compliance, and workforce operations.",
      "brand": { "@id": "https://www.wenodo.com/#organization" },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "22"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://www.wenodo.com/staflexx",
        "price": "0",
        "priceCurrency": "GBP",
        "availability": "https://schema.org/InStock"
      }
    },
 
    {
      "@type": "Service",
      "@id": "https://www.wenodo.com/intelligent-finance/#service",
      "name": "Hospitality Accounting Services",
      "url": "https://www.wenodo.com/intelligent-finance",
      "provider": { "@id": "https://www.wenodo.com/#organization" },
      "description": "End-to-end hospitality accounting services for restaurants, hotels, cafes, and bars."
    },
 
    {
      "@type": "Service",
      "@id": "https://www.wenodo.com/manage-payroll/#service",
      "name": "Restaurant Payroll Services",
      "url": "https://www.wenodo.com/manage-payroll",
      "provider": { "@id": "https://www.wenodo.com/#organization" },
      "description": "Fully managed payroll solutions for restaurants in the UK and UAE."
    },
 
    {
      "@type": "Service",
      "@id": "https://www.wenodo.com/consulting/#service",
      "name": "Restaurant Consulting",
      "url": "https://www.wenodo.com/consulting",
      "provider": { "@id": "https://www.wenodo.com/#organization" },
      "description": "Restaurant consulting for operational efficiency, menu costing, and financial management."
    },
 
    {
      "@type": "Service",
      "@id": "https://www.wenodo.com/payroll-outsourcing/#service",
      "name": "Payroll Outsourcing Services",
      "url": "https://www.wenodo.com/payroll-outsourcing",
      "provider": { "@id": "https://www.wenodo.com/#organization" },
      "description": "Specialized payroll outsourcing for hospitality brands in the UK and UAE."
    },
 
    {
      "@type": "Service",
      "@id": "https://www.wenodo.com/book-a-demo/#service",
      "name": "Book a Demo",
      "url": "https://www.wenodo.com/book-a-demo",
      "provider": { "@id": "https://www.wenodo.com/#organization" },
      "description": "Book a personalized demo of Wenodo software products."
    },
 
    {
      "@type": "FAQPage",
      "@id": "https://www.wenodo.com/#faq",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Which countries does Wenodo serve?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Wenodo serves clients in the UK and UAE with accounting, payroll, consulting, and software solutions."
          }
        },
        {
          "@type": "Question",
          "name": "What industries does Wenodo support?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Wenodo specializes in hospitality including restaurants, cafes, hotels, bars, cloud kitchens, and franchises."
          }
        },
        {
          "@type": "Question",
          "name": "Does Wenodo provide software products?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Wenodo provides Staflexx workforce management software and Trakn AI restaurant analytics software."
          }
        }
      ]
    },
 
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wenodo.com/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.wenodo.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Services",
          "item": "https://www.wenodo.com/services"
        }
      ]
    }
  ]
}

`

const scriptTag = document.createElement('script')
scriptTag.type = 'application/ld+json'
scriptTag.textContent = jsonLdData
document.head.appendChild(scriptTag)
